import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { ValidationBuilderService } from './validation-builder.service';

export const Ng1ValidationBuilderModule = angular
  .module('control-room.shared.services.validation-builder', [])
  .factory('crValidationBuilderService', downgradeInjectable(ValidationBuilderService));